import { c as _c } from "react/compiler-runtime";
import { useQuestionDataQuery, useQuestionOfTodayQuery } from "#/graphql/generated";
export const useDailyQuestionData = options => {
  const $ = _c(11);
  const questionOfTodayQuery = useQuestionOfTodayQuery();
  let t0;
  if ($[0] !== questionOfTodayQuery.data) {
    t0 = questionOfTodayQuery.data ?? {};
    $[0] = questionOfTodayQuery.data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    activeDailyCodingChallengeQuestion
  } = t0;
  const titleSlug = activeDailyCodingChallengeQuestion?.question.titleSlug;
  const t1 = titleSlug || "";
  let t2;
  if ($[2] !== t1) {
    t2 = {
      titleSlug: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !titleSlug;
  let t4;
  if ($[4] !== options || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      variables: t2,
      skip: t3,
      ...options
    };
    $[4] = options;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const questionDataQuery = useQuestionDataQuery(t4);
  const error = questionOfTodayQuery.error ?? questionDataQuery.error;
  let t5;
  if ($[8] !== error || $[9] !== questionDataQuery) {
    t5 = {
      ...questionDataQuery,
      error
    };
    $[8] = error;
    $[9] = questionDataQuery;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};